module.exports = __webpack_public_path__ + "static/media/background.ff67559d.png";